<template>
  <component
    :is="is"
    ref="select"
    v-bind="attrs"
    v-model="value_"
    :auto-init="autoInit"
    :option="optionConfig"
    @blur="blur"
    @focus="focus"
    @change="change"
  ></component>
</template>

<script>
export default {
  props: {
    is: {
      type: String,
      default: 'horizon-select'
    },
    value: {
      type: [String, Array, Boolean, Number],
      default: ''
    },
    // 组件唯一标识
    mark: {
      type: String,
      default: ''
    },
    // 是否自动初始化，即会触发请求默认值数据的方法
    // 在接口支持绑定值过滤或获取全部数据不卡顿的情况下可开启
    autoInit: {
      type: Boolean,
      default: false
    },
    // 是否自动获取焦点，获取焦点的执行操作在初始化之后
    autoFocus: {
      type: Boolean,
      default: false
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      attrs: {},
      isInit: false, // 用于判断初始化是否完成
      // value值并不会随着getVal设置后立即改变
      // 所以设置一个内部insideValue
      insideValue: this.value,
      defaultOption: {
        seledLabel: 'sName',
        label: 'sPath',
        value: ''
      }
    }
  },
  computed: {
    value_: {
      get() {
        return this.insideValue
      },
      set(v) {
        // 设置ag表格值
        this.$emit('getVal', v)
        this.insideValue = v
      }
    },
    optionConfig() {
      // seledLabel字段改名为了selectedLabel
      // 兼容旧版AgSearchSelect之前设置的默认值
      if (this.is === 'horizon-select') {
        return {
          label: 'sPath',
          value: '',
          selectedLabel: this.option.seledLabel || 'sName',
          ...this.option
        }
      }
      // 后期其他类型的select全部按照它内部的默认key的配置不做另外处理
      return this.option
    }
  },
  created() {
    this.mark && this.$emit('getComponent', this)
    this.insideValue = this.value
    // 过滤出props中不存在的属性
    const hasKeys = Object.keys(this.$props)
    const attrKeys = Object.keys(this.$attrs).filter(v => hasKeys.indexOf(v) === -1)
    const attrs = {}
    attrKeys.forEach(v => {
      attrs[v] = this.$attrs[v]
    })
    this.attrs = attrs
  },
  mounted() {
    if (this.autoFocus) {
      if (!this.insideValue || !this.autoInit) {
        this.focusSelect()
        this.isInit = true
      }
    }
  },
  beforeDestroy() {
    const pseudoEvent = {
      mark: 'pseudoEvent',
      target: {
        value: this.value
      }
    }
    this.blur(pseudoEvent)
  },
  methods: {
    change(v, type) {
      // type为false的时候表示是由于绑定值改变，初始化数据导致的change
      if (!type && !this.isInit && this.autoFocus) {
        this.focusSelect()
      }
      this.isInit = true
      // 返回整个对象，部分场景需要其他值
      if (type) {
        this.$emit('getOption', v)
        this.$emit('change', v, type)
      }
    },
    blur(e) {
      this.$emit('blur', e)
    },
    focus(e) {
      this.$emit('focus', e)
    },
    focusSelect() {
      this.$nextTick(() => {
        this.$refs.select.focus()
      })
    }
  }
}
</script>
